export default [
  {
    name: "Memory Game",
    description:
      "Creación del juego 'memorize' de forma básica con la Api de pokemon (https://pokeapi.co/)",
    technologies: [
      "Vue",
      "Vuex",
      "+ES6",
      "SASS",
      "Git",
      "HTML5",
      "CSS3",
      "Pokeapi.co",
      "AWS Amplify",
    ],
    image: require("@/assets/memory.png"),
    url: "https://memory.folivaresrios.com",
    code: {
      public: true,
      url: "https://github.com/folivaresrios/memory_game/",
    },
    categories: ["FrontEnd"],
  },
  {
    name: "Personal Resume",
    description: "Creación de una plantilla para plasmar un resumen/portafolio",
    technologies: [
      "Vue",
      "Vue-Router",
      "TailwindCSS",
      "Axios",
      "Git",
      "HTML5",
      "CSS3",
      "AWS Amplify",
    ],
    image: require("@/assets/resume.png"),
    url: "https://folivaresrios.com",
    code: {
      public: false,
      url: "https://github.com/folivaresrios/resume/",
    },
    categories: ["UI/UX", "FrontEnd"],
  },
];
